import React from 'react';

// 获取内容高度
const getViewHeight = () => {
  // server side
  if (typeof window === 'undefined') {
    return 0;
  }

  const height = (window.innerHeight || document.documentElement.clientHeight);

  return height;
};

const PdfIframe = (props) => {
  const {
    prefixCls = 'crm-pdf-iframe',
    height = getViewHeight(),
    href = '',
  } = props || {};
  const iframeUrl = `//static.iyb.tm/web/lib/pdfjs/mobile/viewer.html?file=${href}`;
  const styles = {
    height,
  };

  return (
    <div
      className={prefixCls}
      style={styles}
    >
      {
        href ? <iframe title="pdf" src={iframeUrl} /> : <div>内容为空</div>
      }
    </div>
  );
};

export default PdfIframe;
